import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Credit from "react-credit-cards";
import UserAvatar from "../UserAvatar/UserAvatar";
import "react-credit-cards/es/styles-compiled.css";
import "./profile.scss";
import axiosInstance from "../../../axios";
import { useDispatch } from "react-redux";
import { userActions } from "../../../_actions";
import {  useLocation, useNavigate } from "react-router";
import { countries } from "../../../_constants/staticData";
import { AuthorizedWrapper } from "../../Other/AuthorizedWrapper";
import Describe from "./Describe";
import { InstructorInfo } from "./InstructorInfo";
import { UploadAvatar } from "./UploadAvatar";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { courseService } from "../../../_services";
import { emailVaildation } from "../../../_helpers";

export default function Profile() {
  const { user } = useSelector((state) => state.users);
  const [profileSettings, setProfileSettings] = useState(0);
  const [uploadAvatar, setUploadAvatar] = useState(false);
  const location = useLocation();
  const { state } = location;

  // let name = "Milan";
  // let name1 = "prq";
  const { t } = useTranslation();
  // const backgroundImg =
  //     "https://www.youcanseethemilkyway.com/wp-content/themes/milkyway/img/1.jpg";

  const menu = [
    {
      key: 0,
      label: t("profile.profile"),
      icon: "",
      component: <BasicInfo />,
    },
    {
      key: 1,
      label: t("Security"),
      icon: "",
      component: <Security />,
    },
    {
      key: 2,
      label: t("Payment Methods"),
      icon: "",
      component: <PaymentMethod setProfileSettings={setProfileSettings} />,
    },
    {
      key: 3,
      label: t("Add a Card"),
      icon: "",
      component: <AddCard />,
    },
    {
      key: 4,
      label: "Notifications",
      icon: "",
      component: <Notifications />,
    },
  ];

  // const handleTransition = (item) => {

  //   if (item === 0) {
  //     setTransitSlide(100);
  //   } else if (item === 1) {
  //     setTransitSlide(210);
  //   } else if (item === 2) {
  //     setTransitSlide(375);
  //   } else if (item === 3) {
  //     setTransitSlide(550);
  //   } else if (item === 4) {
  //     setTransitSlide(700);
  //   }
  // };

  useEffect(() => {
    if (state === "Security") {
      setProfileSettings(1);
    } else if (state === "Profile") {
      setProfileSettings(0);
    }
  }, [state]);

  const handleClick = () => {
    setUploadAvatar((state) => !state);
  };

  return (
    <div className="container-wrapper profile-page-container">
      <div
        className="profile-wrapper"
        // style={{
        //     backgroundImage: `url(${backgroundImg})`,
        // }}
      >
        {user && !uploadAvatar ? (
          <div onClick={handleClick}>
            <UserAvatar styleName="avatar-image" />
          </div>
        ) : (
          <UploadAvatar hideUploadAvatar={setUploadAvatar} />
        )}
      </div>

      {/*
        <div className='wel-left' style={{ zIndex: 100 }}></div>
                 */}

      <div className="tab-wrapper">
        <ul className="align-tab">
          {menu.map((item) => {
            return (
              <li
                className={item.key === profileSettings ? "active" : null}
                key={item.key}
                onClick={() => setProfileSettings(item.key)}
              >
                <a
                  // href={"/" + item.label}
                  href="#!"
                  onClick={() => {
                    setProfileSettings(item.key);
                    // handleTransition(item.key);
                  }}
                  key={item.key}
                >
                  <i className={item.icon} />
                  {item.label}
                </a>
              </li>
            );
          })}
          {/* <li
            className="slider"
            style={{ position: "absolute", left: `${transitSlide}px` }}
          ></li> */}
        </ul>
      </div>
      {/* headers will be here as discussed profile photo and background */}
      <div className="info-wrapper">
        {menu[profileSettings].component}

        {/*
                    <div className="toggle-wrapper">
                        <div className="toggle transparent">
                            <input id="transparent" type="checkbox"/>
                            <label className="toggle-item" htmlFor="transparent"></label>
                        </div>
                    </div>
                    */}
      </div>
    </div>
  );
}

export function BasicInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [errorMsg, setErrorMsg] = useState({ param: "", msg: "" });

  const { user } = useSelector((state) => state.users);

  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    bio: "",
    phoneNumber: "",
    website: "",
    facebook: "",
    youtube: "",
    linkedIn: "",
    twitter: "",
    addressLine1: "",
    addressLine2: "",
    certifications: "",
    city: "",
    state: "",
    country: "",
    qualifications: "",
    publicLocation: "",
    publicLocationCountry: "",
    facebookProfile: "",
    twitterProfile: "",
    youtubeProfile: "",
    introduction: "",
    introductionLink: "",
    languages: "",
  };

  const [userInfo, setUserInfo] = useState(
    user !== undefined ? user : initialState
  );
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };

  const handleClose = () => {
    setShowModal(false);
    navigate("/dashboard/profile");
  };

  const handleSubmit = (e) => {
    setError(true);
    e.preventDefault();
    if (
      userInfo.firstName !== "" &&
      userInfo.lastName !== "" &&
      userInfo.phoneNumber !== ""
    ) {
      const newUserInfo = {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        phoneNumber: userInfo.phoneNumber,
        bio: userInfo.bio,
        addressLine1: userInfo.addressLine1,
        addressLine2: userInfo.addressLine2,
        city: userInfo.city,
        state: userInfo.state,
        country: userInfo.country,
        publicLocation: userInfo.publicLocation,
        publicLocationCountry: userInfo.publicLocationCountry,
        twitterProfile: userInfo.twitterProfile,
        youtubeProfile: userInfo.youtubeProfile,
        facebookProfile: userInfo.facebookProfile,
        linkedProfile: userInfo.linkedProfile,
        introduction: userInfo.introduction,
        introductionLink: userInfo.introductionLink,
        qualifications: userInfo.qualifications,
        certifications: userInfo.certifications,
        languages: userInfo.languages,
      };

      courseService.updateProfile(newUserInfo).then((res) => {
        if (!res?.data?.error) {
          setShowModal(true);
          setErrorMsg({ param: "", msg: "" });
        } else {
          setErrorMsg({
            param: res?.data?.data[0].param,
            msg: res?.data?.data[0].msg,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (user) {
      setUserInfo(user);
    }
  }, [user]);

  return (
    <>
      {showModal && (
        <OverlayContainer>
          <div className="alert-dialog-inner">
            <div className="close-wrapper align-icon" onClick={handleClose}>
              <div className="alert-dialog-close">
                <i className="icon check"></i>
              </div>
            </div>

            <div>
              <div className="alert-title">
                <div className="icon-wrapper">
                  <img
                    src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
                    alt="check-complete"
                  />
                </div>
                <div className="status-message">
                  <div className="status-title">
                    <p>Your profile updated successfully</p>
                  </div>

                  <p>{t("thankYou")}</p>
                </div>
              </div>
            </div>
          </div>
        </OverlayContainer>
      )}

      <div className="form-wrapper">
        <div className="align-title">
          <h3>Public Profile</h3>
          <p>Add short description about yourself</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div
            className={`flex-wrapper ${
              userInfo.firstName === "" && error === true ? "form-error" : ""
            }`}
          >
            <div className="flex-left">
              <input
                type="text"
                placeholder={t("profile.firstName")}
                name="firstName"
                value={userInfo.firstName || ""}
                onChange={handleChange}
                className={`${
                  userInfo.firstName === "" && error === true && "error"
                }`}
              />
            </div>

            <div
              className={`flex-right ${
                userInfo.lastName === "" && error === true ? "form-error" : ""
              }`}
            >
              <input
                type="text"
                placeholder={t("profile.lastName")}
                name="lastName"
                value={userInfo.lastName || ""}
                onChange={handleChange}
                className={`${
                  userInfo.lastName === "" && error === true && "error"
                }`}
              />
            </div>
          </div>
          <AuthorizedWrapper authorizedRoles={["Instructor"]}>
            <div className="flex-wrapper">
              <div className="flex-left">
                <input
                  type="number"
                  placeholder={t("Phone Number")}
                  name="phoneNumber"
                  value={userInfo.phoneNumber || ""}
                  onChange={handleChange}
                  className={`${
                    userInfo.phoneNumber === "" && error === true && "error"
                  }`}
                />
              </div>
              <div className="flex-right">
                <input
                  type="text"
                  placeholder={t("Email")}
                  name="email"
                  value={userInfo.email || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </AuthorizedWrapper>
          <div className="flex-wrapper">
            <div className="flex-left">
              <input
                type="text"
                placeholder={t("profile.address1")}
                name="addressLine1"
                value={userInfo.addressLine1 || ""}
                onChange={handleChange}
              />
            </div>
            <div className="flex-right">
              <input
                type="text"
                placeholder={t("profile.address2")}
                name="addressLine2"
                value={userInfo.addressLine2 || ""}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="flex-wrapper">
            <div className="flex-left">
              <input
                type="text"
                placeholder={t("profile.city")}
                name="city"
                value={userInfo.city || ""}
                onChange={handleChange}
              />
            </div>
            <div className="flex-right">
              <input
                type="text"
                placeholder={t("State OR Province")}
                name="state"
                value={userInfo.state || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <Describe
            userInfo={userInfo}
            handleChange={handleChange}
            error={error}
          />

          <div className="flex-wrapper">
            <div className="flex-left">
              <div className="styled-select">
                <select
                  name="country"
                  onChange={handleChange}
                  defaultValue={userInfo.country ? userInfo.country : ""}
                >
                  <option value="">Select Country</option>
                  {countries.map((country, index) => (
                    <option
                      value={country.name}
                      key={index + 1}
                      //selected={country.name === userInfo.country}
                    >
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <AuthorizedWrapper authorizedRoles={["Student"]}>
            <>
              <div className="align-title social">
                <h3>
                  CONTACT INFORMATION{" "}
                  <span>(Only for Admin/Instructor use)</span>
                </h3>
              </div>
              <div className="flex-wrapper">
                <div className="flex-left">
                  <input
                    type="number"
                    placeholder={t("Phone Number")}
                    name="phoneNumber"
                    value={userInfo.phoneNumber || ""}
                    onChange={handleChange}
                    className={`${
                      userInfo.phoneNumber === "" && error === true && "error"
                    }`}
                    readOnly
                  />
                </div>
                <div className="flex-right">
                  <input
                    type="text"
                    placeholder={t("Email")}
                    name="email"
                    value={userInfo.email || ""}
                    onChange={handleChange}
                    readOnly
                  />
                </div>
              </div>
            </>
          </AuthorizedWrapper>

          <AuthorizedWrapper authorizedRoles={["Instructor"]}>
            <InstructorInfo
              formState={userInfo}
              handleChange={handleChange}
              trasnlate={t}
            />
          </AuthorizedWrapper>

          <div className="align-title social">
            <h3>
              SOCIAL LINKS <span>(Optional)</span>
            </h3>
          </div>
          <div className="flex-wrapper">
            <div className="flex-left">
              <input
                type="text"
                placeholder={t("Twitter profile URL")}
                name="twitterProfile"
                value={userInfo.twitterProfile || ""}
                onChange={handleChange}
              />
              <p className="p-for-error-msg">
                {errorMsg?.param === "twitterProfile" &&
                  "*Twitter url is invalid"}
              </p>
            </div>

            <div className="flex-right">
              <input
                type="text"
                placeholder={t("Linked In URL")}
                name="linkedProfile"
                value={userInfo.linkedProfile || ""}
                onChange={handleChange}
              />
              <p className="p-for-error-msg">
                {errorMsg?.param === "linkedProfile" &&
                  "*Linkdein url is invalid"}
              </p>
            </div>
          </div>
          <div className="flex-wrapper">
            <div className="flex-left">
              <input
                type="text"
                placeholder={t("Facebook profile URL")}
                name="facebookProfile"
                value={userInfo.facebookProfile || ""}
                onChange={handleChange}
              />
              <p className="p-for-error-msg">
                {errorMsg?.param === "facebookProfile" &&
                  "*Facebook url is invalid"}
              </p>
            </div>

            <div className="flex-right">
              <input
                type="text"
                placeholder={t("Youtube URL")}
                name="youtubeProfile"
                value={userInfo.youtubeProfile || ""}
                onChange={handleChange}
              />
              <p className="p-for-error-msg">
                {errorMsg?.param === "youtubeProfile" &&
                  "*Youtube url is invalid"}
              </p>
            </div>
          </div>

          <div className="flex-wrapper">
            <div className="flex-left">
              <button type="submit" className="btn-submit">
                {t("Save Profile")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export function Security() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.users);

  const [email, setEmail] = useState("");
  const [validation, setValidation] = useState(false);
  const [errorMessage, setErrorMesssage] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidation(true);
    const ValidateEmail = emailVaildation(email) ? true : false;
    const data = {
      email: email,
    };

    if (email !== "" && ValidateEmail === false) {
      setErrorMesssage("Please enter a valid email");
    } else if (ValidateEmail !== false) {
      courseService.profileForgetPassword(data).then((response) => {
        if (response.data.error === false) {
          setConfirmation(true);
          setTimeout(() => {
            dispatch(userActions.logout());
            navigate("/");
            localStorage.removeItem("token");
          }, 1500);
        } else if (response.data.error === true) {
          setErrorMesssage(response.data.message);
        }
      });
    }
  };

  return (
    <>
      <div className="align-title">
        <h3>Update Password</h3>
        <p>Update or Change your password for your account</p>
      </div>
      {!confirmation ? (
        <form onSubmit={handleSubmit}>
          <div
            className={`flex-wrapper ${
              email === "" && validation === true ? "form-error" : ""
            }`}
          >
            <input
              placeholder={t("Please enter your email")}
              aria-label="username"
              type="text"
              className={`${email === "" && validation === true && "error"}`}
              value={email}
              onChange={handleChange}
            />
          </div>

          <p className="text-color">{errorMessage}</p>
          <div className="flex-wrapper">
            <div className="flex-left">
              <button type="submit" className="btn-submit">
                {t("Send Email")}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="form-wrapper">
          <div className="center">
            <div className="form-row">
              <p className="form-text">
                Please check your email for a verification message. Click the
                link in the message to change your password.
              </p>
              <p className="form-text">Thank You !</p>
            </div>

            <div className="form-row flex-wrapper">
              <a href="javascript:;" className="resend-btn">
                Resend Verification email
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export function PaymentMethod({ setProfileSettings }) {
  const { t } = useTranslation();

  const handleManageCard = () => {
    setProfileSettings(3);
  };

  return (
    <>
      <div className="align-title">
        <h3>Your Payment Methods</h3>
        <p>Manage your payment methods here</p>
      </div>
      <div className="align-title">
        <div className="align-text">
          <p>Currently you don't have any saved payment methods</p>
        </div>
      </div>
      <div className="flex-wrapper">
        <div className="flex-left">
          <button
            type="submit"
            className="btn-submit"
            onClick={handleManageCard}
          >
            {t("Add a Payment Card")}
          </button>
        </div>
      </div>
    </>
  );
}

export function AddCard() {
  const { t } = useTranslation();
  const [number, setNumber] = useState("");
  const [name, setName] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [focus, setFocus] = useState("");

  return (
    <>
      <div className="align-title">
        <h3>Add a card </h3>
        <p>Add a Credit card to save as a Payment method</p>
      </div>
      <div className="cCard-wrapper flex-wrapper">
        <div className="cCard-left">
          <Credit
            name={name}
            expiry={expiry}
            number={number}
            cvc={cvv}
            focused={focus}
          />
        </div>

        <div className="cCard-right">
          <form>
            <div className="flex-wrapper">
              <span className="icon-holder">
                <i className="icon icon-lock" />
              </span>

              <input
                type="tel"
                name="number"
                maxLength="19"
                placeholder="Credit Card Number"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                onFocus={(e) => setFocus(e.target.name)}
              />
            </div>

            <div className="flex-wrapper">
              <input
                type="text"
                name="name"
                placeholder="Name on card"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={(e) => setFocus(e.target.name)}
                autoComplete="off"
              />
            </div>

            <div className="flex-wrapper">
              <div className="">
                <input
                  type="text"
                  name="expiry"
                  maxLength="4"
                  placeholder="MM/YY"
                  value={expiry}
                  onChange={(e) => setExpiry(e.target.value)}
                  onFocus={(e) => setFocus(e.target.name)}
                  autoComplete="off"
                />
              </div>

              <div className="">
                <input
                  type="tel"
                  name="cvc"
                  maxLength="3"
                  placeholder="CVV"
                  value={cvv}
                  onChange={(e) => setCvv(e.target.value)}
                  onFocus={(e) => setFocus(e.target.name)}
                  autoComplete="off"
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="flex-wrapper">
        <div className="flex-left">
          <input
            placeholder={t("profile.address1")}
            type="text"
            name="street_name"
            autoComplete="off"
          />
        </div>

        <div className="flex-right">
          <input
            type="text"
            placeholder={t("profile.address2")}
            name="unit"
            autoComplete="off"
          />
        </div>
      </div>

      <div className="flex-wrapper">
        <div className="flex-left">
          <input
            type="text"
            placeholder={t("profile.city")}
            name="city"
            autoComplete="off"
          />
        </div>

        <div className="flex-right">
          <input
            type="text"
            placeholder={t("profile.stateProvince")}
            name="province"
            autoComplete="off"
          />
        </div>
      </div>

      <div className="flex-wrapper">
        <div className="flex-left">
          <input
            type="text"
            placeholder={t("profile.postalZipCode")}
            name="po_code"
            autoComplete="off"
          />
        </div>

        <div className="flex-right">
          <div className="styled-select">
            <select>
              {countries.map((cnt) => (
                <option value={cnt.name}>{cnt.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="flex-wrapper">
        <div className="flex-left">
          <button type="submit" className="btn-submit">
            {t("Add this Card")}
          </button>
        </div>
      </div>
    </>
  );
}

export function Notifications() {
  const { t } = useTranslation();

  return (
    <>
      <div className="align-title">
        <h3>Notifications Center</h3>
        <p>Choose what notifications you receive from yslearn</p>
      </div>
      <div className="align-checkbox">
        <div className="align-input">
          <input
            type="checkbox"
            placeholder={t("profile.address2")}
            name="unit"
            defaultChecked
          />
        </div>
        <div className="align-para">
          <p>
            Seasonal Promotions , Discount Codes and periodic updates from team
            yslearn.
          </p>
        </div>
      </div>

      <div className="align-checkbox">
        <div className="align-input">
          <input
            type="checkbox"
            placeholder={t("profile.address2")}
            name="unit"
          />
        </div>
        <div className="align-para">
          <p>
            Communication and announcements from the Instructors for the courses
            you are enrolled in.
          </p>
        </div>
      </div>

      <div className="align-checkbox">
        <div className="align-input">
          <input
            type="checkbox"
            placeholder={t("profile.address2")}
            name="unit"
          />
        </div>
        <div className="align-para">
          <p>Please DO NOT send me any communication and / or promotions.</p>
          <p>
            you will still continue to receive only essential communication ,
            links to download purchase receipts etc.
          </p>
        </div>
      </div>
      <div className="align-checkbox">
        <div className="flex-left">
          <button type="submit" className="btn-submit">
            {t("Save my Preferences")}
          </button>
        </div>
      </div>
    </>
  );
}
